<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>普通问诊</a><i class="el-icon-arrow-right"></i><a>医生详情</a></p>
            </div>
        </div>
        <div class="content">
            <div class="bannerImg">
                <div class="contentListDoc">
                    <div class="contentListDocTop">
                        <div class="DocTopImg">
                            <img v-if="DocOrgDetail.photoFile " :src="http + DocOrgDetail.photoFile">
                            <img v-else src="../../assets/img/consultation/touxiang03.png" alt="">
                        </div>
                        <div class="DocTopImgR">
                            <div class="DocTopFlexS">
                                <div class="DocTopImgRT">
                                    <span class="DocTopImgName">{{DocOrgDetail.userName}}</span>
                                    <img v-if="DocOrgDetail.certificateNumber" src="../../assets/img/consultation/ilabel.png" style="width:60px;height:18px">
                                    <div v-if="DocOrgDetail.levelName == 1" class="DocTopTagZ">{{DocOrgDetail.levelName}}</div>
                                    <div v-if="DocOrgDetail.userCategoryType == 1" class="DocTopTagZ">专家</div>
                                </div>
                                <div v-if="DocOrgDetail.certificateNumber">
                                    <i class="el-icon-document"></i>
                                    <span>证书编号：</span>
                                    <span>{{certificateNumber.substr(0,4)}}*******{{certificateNumber.substr(certificateNumber.length-4,certificateNumber.length-1)}}</span>
                                </div>
                            </div>
                            <div class="DocTopFlexC" style="font-size: 14px;margin-top:5px">
                                <span>{{DocOrgDetail.userTitleName}}</span>
                                <span style="margin:0 5px">|</span>
                                <span>{{DocOrgDetail.userPostName}}</span>
                            </div>
                                <div class="DocTopFlexC" style="font-size: 14px;">
                                <span class="">{{DocOrgDetail.orgName}}</span>
                                <span style="margin:0 5px">|</span>
                                <span>{{DocOrgDetail.departmentName}}</span>
                            </div>
                            <div style="margin-top:15px;font-size: 14px;">
                                <span style="margin-right:30px">问诊量： <span style="font-size: 18px;">{{DocOrgDetail.orderCount}}</span></span>
                                <span style="margin-right:30px">好评率：<span style="font-size: 18px;">{{DocOrgDetail.goodRate + '%'}}</span></span>
                                <span>评分：<span style="font-size: 18px;">{{DocOrgDetail.starRate}}</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-top">
                <div class="diagnose-tab">
                    <span :class="doctorTable == 0 ? 'active' : '' " @click="getTab(0)">主页</span>
                    <span :class="doctorTable == 1 ? 'active' : '' "  @click="getTab(1)">医生介绍</span>
                    <span :class="doctorTable == -1 ? 'active' : '' "  @click="getTab(-1)">患者评价</span>
                </div>
            </div>
        </div>
        <div class="contentRes">
            <div class="contentList">
                <div style="padding: 20px 30px; background: #FFFFFF;" v-if="doctorTable == 0 || doctorTable == 1">
                    <div class="contentPriceBox">
                        <div class="contentListTop" style="margin-bottom:10px">
                            <div class="contentListLine"></div><span>问诊咨询</span>
                        </div>
                    </div>
                    <div class="contentPriceBox">
                        <div class="DocDetailNextBox" v-if="DocOrgDetail.enableOnlineConsultation == 1">
                            <div class="DocTitleNextBox">
                                <img style="width: 36px; height: 30px;" src="../../assets/img/consultation/online.png" alt="" /><span style="margin-left:10px;">在线问诊</span> <span style="color: #00AFB5;margin-left:10px;">￥{{DocOrgDetail.onlineConsultationPrice}}/次</span>
                            </div>
                            <div class="DocDetailYuContent">
                               在线问诊，医生接收后，48小时内可以进行询问诊断，超时将自动结束；如果医生未能解决问题，可以申请退款处理。
                            </div>
                            <div class="DocTopFlexC" style="margin-top:10px">
                                <div class="DocDetailYuBox" @click="goOnlineText">
                                    问诊说明
                                </div>
                                <div class="DocDetailYuBox" @click="goOnlineNextStep">
                                    去问诊
                                </div>
                            </div>
           
                        </div>
                        <div class="DocDetailNextBox" v-if="DocOrgDetail.enableOnlineConsultation == 0" style="opacity: 0.5" @click="goNoMessage">
                            <div class="DocTitleNextBox">
                                <img style="width: 36px; height: 30px;" src="../../assets/img/consultation/online.png" alt="" /><span style="margin-left:10px;">在线问诊</span> <span style="color: #00AFB5;margin-left:10px;">￥{{DocOrgDetail.onlineConsultationPrice}}/次</span>
                            </div>
                            <div class="DocDetailYuContent">
                                在线问诊，医生接收后，48小时内可以进行询问诊断，超时将自动结束；如果医生未能解决问题，可以申请退款处理。
                            </div>
                            <div class="DocTopFlexC" style="margin-top:10px">
                                <div class="DocDetailYuBox">
                                    问诊说明
                                </div>
                                <div class="DocDetailYuBox">
                                    去问诊
                                </div>
                            </div>
           
                        </div>
                        <div class="DocDetailNextBox" v-if="DocOrgDetail.enablePhoneConsultation == 1">
                            <div class="DocTitleNextBox">
                                <img style="width: 36px; height: 30px;" src="../../assets/img/consultation/phone.png" alt="" /><span style="margin-left:10px;">电话问诊</span> <span style="color: #439DF8;margin-left:10px;">￥{{DocOrgDetail.phoneConsultationPrice}}/次</span>
                            </div>
                            <div class="DocDetailYuContent">
                                通过电话与医生直接沟通交流，医生接收后，24小时内会主动与你联系，通话有效时间30分钟，请及时接听。
                            </div>
                            <div class="DocTopFlexC" style="margin-top:10px">
                                <div class="DocDetailYuBox" style="background: #439DF8;" @click="goPhoneText">
                                    问诊说明
                                </div>
                                <div class="DocDetailYuBox" style="background: #439DF8;" @click="goPhoneNextStep">
                                    去问诊
                                </div>
                            </div>
           
                        </div>
                        <div class="DocDetailNextBox" v-if="DocOrgDetail.enablePhoneConsultation == 0" style="opacity: 0.5" @click="goNoMessage">
                            <div class="DocTitleNextBox">
                                <img style="width: 36px; height: 30px;" src="../../assets/img/consultation/phone.png" alt="" /><span style="margin-left:10px;">电话问诊</span> <span style="color: #439DF8;margin-left:10px;">￥{{DocOrgDetail.phoneConsultationPrice}}/次</span>
                            </div>
                            <div class="DocDetailYuContent">
                                通过电话与医生直接沟通交流，医生接收后，24小时内会主动与你联系，通话有效时间30分钟，请及时接听。
                            </div>
                            <div class="DocTopFlexC" style="margin-top:10px">
                                <div class="DocDetailYuBox" style="background: #439DF8;">
                                    问诊说明
                                </div>
                                <div class="DocDetailYuBox" style="background: #439DF8;">
                                    去问诊
                                </div>
                            </div>
           
                        </div>
                    </div>
                </div>
                <div style="padding: 20px 30px; background: #FFFFFF;margin-top:20px" v-if="doctorTable == 0">
                    <div class="contentPriceBox">
                        <div class="contentListTop" style="margin-bottom:10px">
                            <div class="contentListLine"></div><span>医生介绍</span>
                        </div>
                        <div style="font-size: 16px;color: #00AFB5; cursor: pointer;" @click="getTab(1)">查看完整介绍<i class="el-icon-arrow-right"></i></div>
                    </div>
                    <div class="desDoc" style="" v-if="!DocOrgDetail.expertise && !DocOrgDetail.profile">暂未填写</div>
                    <div class="desDoc" style="" v-if="DocOrgDetail.expertise">擅长:{{DocOrgDetail.expertise}}</div>
                    <div class="desDoc" style="margin-top:10px" v-if="DocOrgDetail.profile">简介:{{DocOrgDetail.profile}}</div>
                </div>
                <div style="padding: 20px 30px; background: #FFFFFF;margin-top:20px" v-if="doctorTable == 1">
                    <div class="contentPriceBox">
                        <div class="contentListTop" style="margin-bottom:10px">
                            <div class="contentListLine"></div><span>医生介绍</span>
                        </div>
                    </div>
                    <div  style="" v-if="!DocOrgDetail.expertise && !DocOrgDetail.profile">暂未填写</div>
                    <div class="" style="" v-if="DocOrgDetail.expertise">擅长:{{DocOrgDetail.expertise}}</div>
                    <div class="" style="margin-top:10px" v-if="DocOrgDetail.profile">简介:{{DocOrgDetail.profile}}</div>
                </div>
                <div style="padding: 20px 30px; background: #FFFFFF;margin-top:20px" v-if="doctorTable == 0">
                    <div class="contentPriceBox">
                        <div class="contentListTop" style="margin-bottom:10px">
                            <div class="contentListLine"></div><span>患者评价</span>
                        </div>
                        <div style="font-size: 16px;color: #00AFB5; cursor: pointer;"  @click="getTab(-1)">查看全部评价<i class="el-icon-arrow-right"></i></div>
                    </div>
                    <div v-for="(item,index) in evaluateList" :key="index" style="border-bottom: 1px solid #E6E6E6;padding-bottom:15px;margin-top:15px">
                        <div class="contentPriceBox">
                            <div class="DocTopFlexC">
                                <img v-if="item.userAvatar " style="width:30px;height:30px;border-radius: 50%;" :src="http + item.userAvatar" srcset="">
                                <img v-else style="width:30px;height:30px;border-radius: 50%;" src="../../assets/img/consultation/touxiang03.png" alt="" srcset="">
                                <span style="margin-left:5px;font-size: 18px;color: #333333;">{{item.userName}}</span> 
                            </div>
                             <el-rate v-model="item.star" disabled></el-rate>
                        </div>
                        <div style="margin-top:10px;font-size: 16px;color: #333333;">
                            {{item.content}}
                        </div>
                        <div class="contentPriceBox" style="margin-top:10px;font-size: 14px;color: #999999;">
                            <span v-if="item.orderType == 1">问诊类型: 电话问诊</span>
                            <span v-if="item.orderType == 2">问诊类型: 在线问诊</span>
                            <span>{{item.createTime.split('T')[0]}}</span>
                        </div>
                        <div v-if="item.replyContent" style="background: #F5F5F5;border-radius: 2px;padding:15px;margin-top:10px;">
                            <span style="font-weight: bold;margin-right: 5px;font-size: 16px">医生回复:</span>
                            <span style="color: #333333;font-size: 16px;">{{item.replyContent}}</span>
                        </div>
                    </div>
                    <div v-if="evaluateList.length == 0" style="margin-top:50px; display: flex;align-items: center;flex-direction: column;">
                        <img src="../../assets/img/consultation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                        <span style="color: #666666;">暂无数据！</span>
                    </div>
                </div>
                <div style="padding: 20px 30px; background: #FFFFFF;" v-if="doctorTable == -1">
                    <div class="contentPriceBox">
                        <div class="contentListTop" style="margin-bottom:10px">
                            <div class="contentListLine"></div><span >患者评价 <span style="margin-left:10px"></span>{{dataTotal > 1000 ? '1000+' : dataTotal }}</span>
                        </div>
                    </div>
                    <div class="DocTopFlexC" style="margin-bottom:30px">
                        <div :class="type == 0 ? 'evaBoxCheck' : 'evaBox' " @click="goChooseType(0)">全部</div>
                        <div :class="type == 1 ? 'evaBoxCheck' : 'evaBox' " @click="goChooseType(1)">最新<span style="margin-left: 5px;">{{EvaluateNum.latestCount}}</span></div>
                        <div :class="type == 2 ? 'evaBoxCheck' : 'evaBox' " @click="goChooseType(2)">在线咨询<span style="margin-left: 5px;">{{EvaluateNum.onlineCount}}</span></div>
                        <div :class="type == 3 ? 'evaBoxCheck' : 'evaBox' " @click="goChooseType(3)">电话咨询<span style="margin-left: 5px;">{{EvaluateNum.phoneCount}}</span></div>
                        <div :class="type == 4 ? 'evaBoxCheck' : 'evaBox' " @click="goChooseType(4)">好/中评<span style="margin-left: 5px;">{{EvaluateNum.goodOrMiddleCount}}</span></div>
                        <div :class="type == 5 ? 'evaBoxCheck' : 'evaBox' " @click="goChooseType(5)">差评<span style="margin-left: 5px;">{{EvaluateNum.badCount}}</span></div>
                    </div>
                    <div v-for="(item,index) in evaluateListAll" :key="index" style="border-bottom: 1px solid #E6E6E6;padding-bottom:15px;margin-top:15px">
                        <div class="contentPriceBox">
                            <div class="DocTopFlexC">
                                <img v-if="item.userAvatar " style="width:30px;height:30px;border-radius: 50%;" :src="http + item.userAvatar" srcset="">
                                <img v-else style="width:30px;height:30px;border-radius: 50%;" src="../../assets/img/consultation/touxiang03.png" alt="" srcset="">
                                <span style="margin-left:5px;font-size: 18px;color: #333333;">{{item.userName}}</span> 
                            </div>
                             <el-rate v-model="item.star" disabled></el-rate>
                        </div>
                        <div style="margin-top:10px;font-size: 16px;color: #333333;">
                            {{item.content}}
                        </div>
                        <div class="contentPriceBox" style="margin-top:10px;font-size: 14px;color: #999999;">
                            <span v-if="item.orderType == 1">问诊类型: 电话问诊</span>
                            <span v-if="item.orderType == 2">问诊类型: 在线问诊</span>
                            <span>{{item.createTime.split('T')[0]}}</span>
                        </div>
                        <div v-if="item.replyContent" style="background: #F5F5F5;border-radius: 2px;padding:15px;margin-top:10px;">
                            <span style="font-weight: bold;margin-right: 5px;font-size: 16px">医生回复:</span>
                            <span style="color: #333333;font-size: 16px;">{{item.replyContent}}</span>
                        </div>
                    </div>
                    <div v-if="evaluateListAll.length > 0" style="text-align:right; margin-top:20px">
                        <el-pagination 
                            background
                            @current-change="handleCurrentChange"
                            :current-page.sync ="pageIndex"
                            :page-size="10"
                            layout="total, prev, pager, next"
                            :total="dataTotal">
                        </el-pagination>
                    </div>
                    <div v-if="evaluateListAll.length == 0" style="margin-top:50px; display: flex;align-items: center;flex-direction: column;">
                        <img src="../../assets/img/consultation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                        <span style="color: #666666;">暂无数据！</span>
                    </div>
                </div>
            </div>
            <div class="contentListRight">
                <div style="margin: 19px 31px 28px 23px;">
                    <div class="contentListTopR">
                        <div class="contentListLineR"></div><span>温馨提示</span>
                    </div>
                    <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                        本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                    </div>
                </div>
            </div>
        </div>
        <ft-com></ft-com>
    </div>
</template>

<script>
import { consultationMain } from "../../components/consultation/consultation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
export default {
    components: {
        hdCom,
        ftCom,
    },
    data() {
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        var consultationDrugItem = new consultationMain(this.TokenClient, this.Services.Drug);
        return {
            consultationDomain: consultationMainItem,
            consultationDrugDomain:consultationDrugItem,
            DocOrgDetail:JSON.parse(this.$route.query.DocDetail),
            doctorTable:0,
            evaluateList:[],
            evaluateListAll:[],
            EvaluateNum:{},
            pageIndex:1,
            pageTotal:0,
            pageCount:0,
            http:'',
            certificateNumber:'',
            type:0
        }
    },
    mounted(){
        this.http = this.Services.ossUpload;
        this.certificateNumber=this.DocOrgDetail.certificateNumber.split('-').join('');
        this.getDocListData()
        this.GetEvaluateData()
    },
    methods: {
        goPhoneText(){
            const href = this.$router.resolve("/company/onPhoneDes");
            window.open(href.href, "_blank");
        },
        goOnlineText(){
            const href = this.$router.resolve("/company/onLineDes");
            window.open(href.href, "_blank");
        },
        goOnlineNextStep(){
            this.$router.push({
                path: "/consultation/cosDocDetailInfo",
                  query: {
                    DocId: this.DocOrgDetail.id,
                    type:2
                },
            });
        },
        goPhoneNextStep(){
            this.$router.push({
                path: "/consultation/cosDocDetailInfo",
                query: {
                    DocId: this.DocOrgDetail.id,
                    type:1
                },
            });
        },
        goNoMessage(){
            this.$message({
            message: '该医生暂未开启该问诊方式',
            type: 'warning'
            });
        },
        goChooseType(e){
            this.type = e
            this.pageIndex = 1
            this.evaluateListAll = []
            this.GetEvaluateAllData()
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.GetEvaluateAllData()
        },
        getTab(e){
            this.doctorTable = e
            if (e == -1) {
               this.GetEvaluateTotalData()
               this.GetEvaluateAllData()
            }
        },
        GetEvaluateTotalData(){
            var _this = this
            _this.consultationDrugDomain.GetEvaluateTotal(_this.DocOrgDetail.id,function (data) {
                _this.EvaluateNum = data.data
            },
            function (error) {
                 _this.EvaluateNum = {}
                console.log('', error)
            })
        },
        GetEvaluateData(){
            var _this = this
            _this.consultationDrugDomain.GetEvaluate(_this.DocOrgDetail.id, '0', _this.pageIndex, '15',function (data) {
                _this.dataTotal = data.data.dataTotal
                _this.pageCount = data.data.pageCount
                if (data.data.results.length > 3)  {
                    _this.evaluateList = data.data.results.slice(0,3)
                } else {
                    _this.evaluateList = data.data.results
                }
            },
            function (error) {
                 _this.evaluateList = []
                console.log('', error)
            })
        },
        GetEvaluateAllData(){
            var _this = this
            _this.consultationDrugDomain.GetEvaluate(_this.DocOrgDetail.id, _this.type, _this.pageIndex, '10',function (data) {
                _this.dataTotal = data.data.dataTotal
                _this.pageCount = data.data.pageCount
                _this.evaluateListAll = data.data.results
            },
            function (error) {
                _this.evaluateListAll = []
                console.log('', error)
            })
        },
        getDocListData(){
            var _this = this
            _this.consultationDomain.GetUserInfo(_this.DocOrgDetail.id, function (data) {
                _this.DocOrgDetail.profile = data.data.profile
            },
            function (error) {
                 _this.DocOrgDetail = {}
                console.log('', error)
            })
        },
    },
}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.content {
  width: 1200px;
    margin: 0 auto;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.bannerImg {
    /* height: 150px; */
    background: linear-gradient(90deg, #00AFB5, #12C7AC);
    border-radius: 6px 6px 0px 0px;
}
.content-top {
  height: 64px;
  background: #ffffff;
  box-shadow: 2px 0 5px rgba(102, 102, 102, 0.08);
}
.diagnose-tab {
    padding: 20px 30px;
    padding-bottom: 0px;
    cursor: pointer;
    border-radius: 0px 0px 6px 6px;
}
.diagnose-tab span {
  margin-right: 50px;
  color: #808080;
  font-size: 16px;
   padding-bottom: 20px;
}

.diagnose-tab span.active {
  color: #00A8AE;
  border-bottom: 2px solid #00A8AE;
}
.contentList {
    margin-top: 20px;
   
    width: 800px;

}
.contentListTop {
    display: flex;
    align-items: center;
    font-size: 20px;
}
.contentListTop3 {
    display: flex;
    align-items: center;
    position: relative;
     cursor: pointer;
}
.contentListLine {
    width: 3px;
    height: 20px;
    background: #00AFB5;
    border-radius: 2px;
}
.contentListTop span {
   font-size: 20px;
   margin-left: 10px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.contentListDoc {
   padding: 30px;
}
.contentListDocTop {
    display: flex;
    align-items: center;
}
.DocTopImg {
    width: 120px;
    height: 120px;
    position: relative;
}
.DocTopImg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.DocTopTag {
    width: 60px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.DocTopImgR {
    margin-left: 16px;
    border-radius: 8px;
    padding: 20px;
    padding-bottom: 15px;
    position: relative;
    width: 700px;
    background: #21c2b9;
    color: #ffffff;
    
}
.DocTopImgName {
    font-weight: bold;
    font-size: 18px;
    margin-right: 7px;
}
.DocTopTagZ {
    width: 40px;
    background: #677AEC;
    border-radius: 3px;
    font-size: 10px;
    color: #FFFFFF;
    text-align: center;
    margin-left: 7px;
}
.DocTopImgRT {
    display: flex;
    align-items: center;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexS {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.desDoc{
    margin-top:10px;
    font-size: 16px;
    color: #666666;
    overflow: hidden;/*超出部分隐藏*/
    /* white-space: nowrap; */
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical
}
.orgDes {
/* 		display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical; */
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;/*超出部分文字以...显示*/
    /* width: 60%; */
}
.DocDetailNextBox {
    background: #F2FEFE;
    border-radius: 6px;
    border: 1px solid #ACD7D8;
    padding: 20px;
    margin-bottom: 10px;
    width: 320px;
}
.DocTitleNextBox {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    display: flex;
    align-items: center;
}
.DocDetailYuBox {
    width: 80px;
    background: #00AFB5;
    border-radius: 5px;
    text-align: center;
    padding: 3px 0;
    font-size: 14px;
    color: #FFFFFF;
    margin-right: 10px;
    cursor: pointer;
}
.DocDetailYuContent {
    font-size: 14px;
    color: #668080;
    margin-top: 10px;
}
.contentPriceBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.evaBox {
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    font-size: 16px;
    color: #333333;
    padding:5px 15px;
    margin-right: 12px;
    cursor: pointer;
}
.evaBoxCheck {
    background: #F2FEFE;
    border-radius: 4px;
    border: 1px solid #00AFB5;
    padding:5px 15px;
    font-size: 16px;
    color: #00A8AE;
    margin-right: 12px;
    cursor: pointer;
}
</style>
